import StepTab from '../../../../components/StepperTabs/StepTab';
import StepperTabs from '../../../../components/StepperTabs/StepperTabs';
import { ButtonNextStep, ButtonPrevStep } from '../../../../components/buttons/ButtonNavigation';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import CreateEventApp from './Functionality/CreateEventApp';
import React from 'react';
import ReservationsDetails from './steps/ReservationsDetails';
import ScheduleLocation from './steps/ScheduleLocation';
import AttendeesTypes from './steps/AttendeesTypes';
import ReservationSummary from './steps/ReservationSummary';
import { STEPS_CREATE_RESERVATIONS } from './Model/Models';
import WhiteListTabs from "./steps/WhiteListTabs";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CreateEvent = () => {
    const {
        t,
        steps,
        activeStep,
        setActiveStep,
        eventDetail,
        setEventDetail,
        selectedHost, setSelectedHost,
        handleChange,
        usersSelected,
        setUsersSelected,
        emptyFields,
        setEmptyFields,
        userData,
        photoPickerFile,
        setPhotoPickerFile,
        defaultTolerance,
        handleStepChange,
        handleCreate,
        handleClearSteps,
        handleValidateSteps
    } = CreateEventApp();


    return (
        <>
            <HeadTittle name={'create'} link={routes.event.list} />

            <StepperTabs
                id={null}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => { }}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CREATE_RESERVATIONS.DETAILS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_RESERVATIONS.DETAILS.INDEX && (
                        <>
                            <div className={'row'}>
                                <ReservationsDetails
                                    t={t}
                                    eventDetail={eventDetail}
                                    handleChange={handleChange}
                                    emptyFields={emptyFields}
                                    selectedList={selectedHost}
                                    setSelectedList={setSelectedHost}
                                    handleClearSteps={() => {
                                        handleClearSteps(0);
                                    }}
                                />
                            </div>

                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_ce_next_details'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps(0)) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_CREATE_RESERVATIONS.SCHEDULE_LOCATION.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_RESERVATIONS.SCHEDULE_LOCATION.INDEX && (
                        <>
                            <ScheduleLocation
                                defaultTolerance={defaultTolerance}
                                eventDetail={eventDetail}
                                setEventDetail={setEventDetail}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                handleClearSteps={() => {
                                    handleClearSteps(STEPS_CREATE_RESERVATIONS.SCHEDULE_LOCATION.INDEX);
                                }}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_location'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_location'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleValidateSteps(STEPS_CREATE_RESERVATIONS.SCHEDULE_LOCATION.INDEX)) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_RESERVATIONS.ATTENDEES_TYPES.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_RESERVATIONS.ATTENDEES_TYPES.INDEX && (
                        <>
                            <AttendeesTypes
                                usersSelected={usersSelected}
                                setUsersSelected={setUsersSelected}
                                eventDetail={eventDetail}
                                handleClearSteps={() => {
                                    handleClearSteps(STEPS_CREATE_RESERVATIONS.ATTENDEES_TYPES.INDEX);
                                }}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_attendees'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_white_list'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleValidateSteps(STEPS_CREATE_RESERVATIONS.ATTENDEES_TYPES.INDEX)) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                            setEmptyFields(false);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_RESERVATIONS.WHITE_LIST.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_RESERVATIONS.WHITE_LIST.INDEX && (
                        <>
                            <div className={'row'}>

                                <WhiteListTabs
                                    eventDetail={eventDetail}
                                    setEventDetail={setEventDetail}
                                    handleChange={handleChange}
                                    emptyFields={emptyFields}
                                    setEmptyFields={setEmptyFields}
                                    selectedList={selectedHost}
                                    setSelectedList={setSelectedHost}
                                    photoPickerFile={photoPickerFile}
                                    setPhotoPickerFile={setPhotoPickerFile}
                                />
                            </div>

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_attendees'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_summary'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        setActiveStep((prevStep) => prevStep + 1)
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_CREATE_RESERVATIONS.SUMMARY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_RESERVATIONS.SUMMARY.INDEX && (
                        <>
                            <ReservationSummary
                                eventDetail={eventDetail}
                                selectedHost={selectedHost}
                                usersSelected={usersSelected}
                                userData={userData}
                                photoPickerFile={photoPickerFile}
                                defaultTolerance={defaultTolerance}
                            />

                            <div className='d-flex justify-content-between px-0 mb-2'>
                                <ButtonPrevStep
                                    id='btn_ce_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_create_reservation'
                                    text='create'
                                    click={() => {
                                        handleCreate();
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>
            </StepperTabs>

        </>
    );
};

export default CreateEvent;
